// CommentBottomToggle.jsx

import React from 'react';

// CSS
import './CommentBottomToggle.css';

/**
 * CommentBottomToggle component
 * 
 * Renders a comment replies toggle button for a comment.
 *
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentBottomToggle = ({ 
    comment,
    hasMoreReplies,
    showReplies,
    replies,
    displayedReplies,
    onExpand, 
    onHide 
}) => {

    // ----- RENDER ----- //

    return (

        <div className="comment-bottom-toggle-container">

            {/* BAR */}
            {(hasMoreReplies || showReplies[comment.key]) && (
                <div
                  className="comment-bottom-toggle-bar"
                ></div>
            )}

            {/* REPLIES */}
            {hasMoreReplies && (

                <div
                  className="comment-bottom-toggle-replies"
                  onClick={onExpand}
                >
                    View {replies.length - displayedReplies.length} more
                </div>
            )}

            {/* REPLIES */}
            {showReplies[comment.key] && (
                <div
                  className="comment-bottom-toggle-replies"
                  style={{
                    cursor: 'pointer',
                    marginLeft: hasMoreReplies ? '10px' : '0',
                  }}
                  onClick={onHide}
                >
                    Hide
                </div>
            )}
        </div>

    );
};

// Dev Tools
CommentBottomToggle.displayName = 'CommentBottomToggle';

export default CommentBottomToggle;
